import { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";
import { Stock, Token } from "@/src/features/api/openData";
import { NewsThemes } from "@/src/screens";
import { ThemeWithMarketData } from "@/src/componentsv1/themes/type";
import type { NewsAnalyst, NewsTheme } from "@/src/utils/fetchHotNews";

export const AIInsightTypeEnum = {
  CRYPTO: "crypto",
  US_STOCK: "us-stocks",
  HK_STOCK: "hk-stocks",
} as const;

export type AIInsightType =
  (typeof AIInsightTypeEnum)[keyof typeof AIInsightTypeEnum];

export const AIInsightContentTabTypeEnum = {
  NEWS: "news",
  BREAKING_NEWS: "breaking-news",
} as const;

export type AIInsightContentTabType =
  | "news"
  | "market-report"
  | "breaking-news";

export type AIInsightDocsContentTabProps = {
  contentType?: AIInsightContentTabType;
  className?: string;
  category?: string;
  deviceType?: "mobile" | "desktop";
};

export type AIInsightTabProps = {
  category: string;
  className?: string;
  contentType?: string;
};

// interface Token {
//   name: string;
//   icon: string;
//   sentiment_type: "BULLISH" | "NEUTRAL";
// }

export type DocsHeaderProps = {
  title: string;
  category?: string;
  contentType?: AIInsightContentTabType;
  tokens?: Token[];
  headImage: string;
  author: {
    logo: string;
    name: string;
    time: string;
  };
  /** 有则优先用于头像与署名展示 */
  analyst?: NewsAnalyst | null;
  locale: string;
  deviceType: DeviceType;
  theme?: ThemeWithMarketData;
  /** SSR 注入的主题行（含 parentTheme），用于 news 频道面包屑与子主题链接 */
  newsThemeItem?: NewsTheme["themeItem"];
  summary?: string;
  enTitle?: string;
  // source?: any;
};

export interface BreadcrumbItem {
  /** 显示的文本 */
  label: string;
  /** 链接地址，如果为空则表示当前页面 */
  href?: string;
  /** 是否禁用链接 */
  disabled?: boolean;
}

export interface BreadcrumbProps {
  /** 面包屑项目列表 */
  items: BreadcrumbItem[];
  /** 分隔符图标名称 */
  separatorIcon?: string;
  /** 自定义样式类名 */
  className?: string;
  /** 最大显示项目数量，超出部分将显示省略号 */
  maxItems?: number;
  /** 是否显示主页图标 */
  showHomeIcon?: boolean;
  /** 主页链接地址 */
  homeHref?: string;
}

export interface DocsPriceChangeProps {
  data: Token[] | Stock[];
  locale: string;
  category?: AIInsightType;
  deviceType: DeviceType;
}

export interface AIInsightThemesProps {
  className?: string;
  category: string;
  locale: string;
  selectedTheme: NewsThemes;
  setSelectedTheme: (theme: NewsThemes) => void;
  deviceType?: "mobile" | "desktop";
  closeComponent?: React.ReactNode;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isLoading: boolean;
  staticThemesList: NewsThemes[];
  dynamicThemesList: NewsThemes[];
}
